export var isNotNull = function (value) { return value !== null; };
//# sourceMappingURL=isNotNull.js.map